/**
 * CheckBox Component
 *
 * @param checkValue
 * @param texte
 * @param name
 * @param onChange
 * @returns {JSX.Element}
 * @constructor
 */
const CheckBox = ({checkValue, texte, name, onChange, anchorText, anchorLink, type}) => {
	return (
		<>
			{type === 'anchor' ? (
				<div onClick={() => onChange(checkValue, name)}>

					<label className="active">
						<input type="checkbox"
							   checked={checkValue}
							   name={name}
							   onChange={onChange}
							   title={texte}/>
						{texte}
					</label>
					<a href={anchorLink} target={'_blank'}>{anchorText}</a>
				</div>
			) : (
				<div onClick={() => onChange(checkValue, name)}>

					<label className="active">
						<input type="checkbox"
							   checked={checkValue}
							   name={name}
							   onChange={onChange}
							   title={texte}/>
						{texte}
					</label>
				</div>
			)}
		</>

	)
}

export default CheckBox
